/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_MandarinInputs */

const en_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandarin`)
};

const fr_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandarin`)
};

const de_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandarin`)
};

const it_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandarino`)
};

const ru_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мандарин`)
};

const es_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mandarín`)
};

const zh_cn2_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`普通话`)
};

const ja_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北京語`)
};

const hi_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अकर्मण्य`)
};

const pt_pt2_speechmatics_target_language_mandarin = /** @type {(inputs: Speechmatics_Target_Language_MandarinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandarim`)
};

/**
* | output |
* | --- |
* | "Mandarin" |
*
* @param {Speechmatics_Target_Language_MandarinInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_mandarin = /** @type {((inputs?: Speechmatics_Target_Language_MandarinInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_MandarinInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_mandarin(inputs)
	if (locale === "de") return de_speechmatics_target_language_mandarin(inputs)
	if (locale === "it") return it_speechmatics_target_language_mandarin(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_mandarin(inputs)
	if (locale === "es") return es_speechmatics_target_language_mandarin(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_mandarin(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_mandarin(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_mandarin(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_mandarin(inputs)
	return en_speechmatics_target_language_mandarin(inputs)
});